<template>
  <v-dialog v-model="showForm" max-width="500px" @click:outside="close">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small icon v-on="on" :attrs="attrs">
        <v-icon>ri-account-box-line</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Editar
      </v-card-title>

      <v-card-text>
        <v-combobox
          label="Encaminhar para"
          v-model="medicalRequest.forwardTo"
          dense
          outlined
          :items="doctorUsers"
          :hide-details="!errors.forwardTo"
          :error-messages="errors.forwardTo"
          item-text="employee.name"
          background-color="white"
        />
      </v-card-text>

      <v-card-text>  
        <v-combobox
          label="Local"
          v-model="medicalRequest.site"
          dense
          outlined
          :items="sites"
          :hide-details="!errors.site"
          :error-messages="errors.site"
          :disabled="disableSiteField"
          item-text="site"
          background-color="white"
        />
      </v-card-text>

      <v-card-text>
        <v-text-field
          label="Observações"
          v-model="medicalRequest.observation"
          dense
          outlined
          item-text="observation"
          background-color="white"
        />
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>

        <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CHANGE_MEDICAL_REQUEST from "@/graphql/medical_request/update_medical_request.gql";
export default {
  name: "EditMedicalRequestButton",
  props: {
    medicalRequest: Object,
  },
  data() {
    return {
      showForm: false,
      sites: [
        "Olho direito",
        "Olho esquerdo",
        "Pálpebra direta",
        "Pálpebra esquerda",
      ],
      errors: {},
    };
  },
  apollo: {
    users: {
      query: require("@/graphql/users.gql"),
      result() {
        if (this.$store?.state?.authentication?.user?.id) {
          let userId = this.$store.state.authentication.user.id;

          this.requester = this.lodash.find(this.doctorUsers, {
            id: userId,
          });
        }
      },
    },
  },
  computed: {
    doctorUsers() {
      return this.lodash.orderBy(
        this.lodash.filter(this.users, {
          employee: { employeeType: "doctor" },
        }),
        [
          (e) =>
            e.employee.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    disableSiteField(){
      return this.medicalRequest.requestedQuantity > 1
    },
  },
  methods: {
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: CHANGE_MEDICAL_REQUEST,
        variables: {
          medicalRequestId: this.medicalRequest.id,
          forwardToId: this.medicalRequest.forwardTo.id,
          observation: this.medicalRequest.observation,
          site: this.medicalRequest.site
        },
      })
        .then(() => {
          this.$store.dispatch("createNotification", {
            message: `Informações alteradas com sucesso!`,
            type: "success",
          });
        })
        .catch((error) => {
          const errorMessage = error.message.replace("GraphQL error: ", "");

          this.$store.dispatch("createNotification", {
            message: errorMessage,
            type: "error",
          });
        });
      this.close();
    },
    close() {
      this.showForm = false;

    },
    validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        const site = this.medicalRequest.site;
        const forwardTo = this.medicalRequest.forwardTo;

        if (site === null || this.lodash.isEmpty(site)){
          this.errors.site = errorMsg;
        }

        if(forwardTo == null) {
          this.errors.forwardTo = errorMsg;
        }

        return this.lodash.isEmpty(this.errors);
      },
  },
};
</script>

<style lang="scss" scoped></style>
